
      // init analytics
      import { init } from './src/services/analytics.js'
      init()
    